import type { HTMLAttributes } from 'react'

/** As quatro marcas de registro do frame "blueprint" do DS. Coloque dentro de qualquer elemento `.blueprint`. */
export function Corners() {
  return (
    <>
      <i className="corner tl" />
      <i className="corner tr" />
      <i className="corner bl" />
      <i className="corner br" />
    </>
  )
}

/** `<div class="blueprint">` já com as marcas. Para botões use `className="btn … blueprint"` + `<Corners />`. */
export function Blueprint({ className = '', children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div {...rest} className={`blueprint ${className}`}>
      <Corners />
      {children}
    </div>
  )
}
